import png100 from './100.png';
import png101 from './101.png';
import png102 from './102.png';
import png103 from './103.png';
import png104 from './104.png';
import png150 from './150.png';
import png153 from './153.png';
import png154 from './154.png';
import png300 from './300.png';
import png301 from './301.png';
import png302 from './302.png';
import png303 from './303.png';
import png304 from './304.png';
import png305 from './305.png';
import png306 from './306.png';
import png307 from './307.png';
import png308 from './308.png';
import png309 from './309.png';
import png310 from './310.png';
import png311 from './311.png';
import png312 from './312.png';
import png313 from './313.png';
import png314 from './314.png';
import png315 from './315.png';
import png316 from './316.png';
import png317 from './317.png';
import png318 from './318.png';
import png350 from './350.png';
import png351 from './351.png';
import png399 from './399.png';
import png400 from './400.png';
import png401 from './401.png';
import png402 from './402.png';
import png403 from './403.png';
import png404 from './404.png';
import png405 from './405.png';
import png406 from './406.png';
import png407 from './407.png';
import png408 from './408.png';
import png409 from './409.png';
import png410 from './410.png';
import png456 from './456.png';
import png457 from './457.png';
import png499 from './499.png';
import png500 from './500.png';
import png501 from './501.png';
import png502 from './502.png';
import png503 from './503.png';
import png504 from './504.png';
import png507 from './507.png';
import png508 from './508.png';
import png509 from './509.png';
import png510 from './510.png';
import png511 from './511.png';
import png512 from './512.png';
import png513 from './513.png';
import png514 from './514.png';
import png515 from './515.png';
import png900 from './900.png';
import png901 from './901.png';
import png999 from './999.png';

export default {
  png100,
  png101,
  png102,
  png103,
  png104,
  png150,
  png153,
  png154,
  png300,
  png301,
  png302,
  png303,
  png304,
  png305,
  png306,
  png307,
  png308,
  png309,
  png310,
  png311,
  png312,
  png313,
  png314,
  png315,
  png316,
  png317,
  png318,
  png350,
  png351,
  png399,
  png400,
  png401,
  png402,
  png403,
  png404,
  png405,
  png406,
  png407,
  png408,
  png409,
  png410,
  png456,
  png457,
  png499,
  png500,
  png501,
  png502,
  png503,
  png504,
  png507,
  png508,
  png509,
  png510,
  png511,
  png512,
  png513,
  png514,
  png515,
  png900,
  png901,
  png999
};
